// extracted by mini-css-extract-plugin
export default {"TribehubCalendar":"Calendar_TribehubCalendar__i6Pui"};